require('./mortgageRequestSimpleNote.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const {
    clone, cloneDeep, extend, isEmpty, union, filter,
    takeRight, each, every, isEqual, map, once, find
} = require('lodash');
const classnames = require('classnames');

// @ utilities
const { recordProcess, PROC_START, PROC_CANCEL, PROC_RESTART } = require('utilities/tagging');
const { getMultiples, getTexts, getTextDescription, getTextLinkDescription } = require('utilities/dragNDropUpload');

// @ track processes
const { PROC_ADD_SIMPLE_NOTE } = require('constants/mortgageRequestProcesses');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');
const Modal = require('./modal');

const { APORTAR_DOC } = require('constants/mortgageRequestStates');
// @ constants
const { ESTATES_TYPE, DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');
const DOCUMENTS_TYPES = require('constants/mortgageRequestDocumentsTypes');
const {
    DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT,
    DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE,
    DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME,
    DRAG_N_DROP_UPLOAD_MAX_SIZE,
    DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES,
    DRAG_N_DROP_UPLOAD_TITLE,
    DRAG_N_DROP_UPLOAD_ERROR_MESSAGE,
    DRAG_N_DROP_UPLOAD_FILE_TEXT
} = require('constants/commonsComponents');
const SELECT_OPTIONS = {
    REQUEST: 'request',
    UPLOAD: 'upload'
};

const URLS = {
    PANEL: '/myprofile/mortgage/panel',
    UPLOADED_NS: '/myprofile/mortgage/simple-note-uploaded',
    REQUEST_NS: '/myprofile/mortgage/simple-note-request'
};

// @ actions
const simpleNoteActions = require('actions/mortgageRequest/mortgageRequestSimpleNote');
const mortgageInmueblesActions = require('actions/mortgageRequest/mortgageRequestInmuebles');
const mortgageRequestEstatesActions = require('actions/mortgageRequest/mortgageRequestEstates');
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');

class MortgageRequestSimpleNote extends React.Component {
    constructor(props) {
        super(props);

        this.estates = [];
        this.estatesDocuments = {};
        this.uploadFiles = {};
        this.redirect = '';
        this.savedOptions = {};

        this.state = {
            showModal: false,
            optionSelected: {},
            fileErrors: {},
            isUploading: false
        };

        this.handleOnChangeSelect = this.handleOnChangeSelect.bind(this);
        this.handleOnChangeFile = this.handleOnChangeFile.bind(this);
        this.handleOnDownloadFile = this.handleOnDownloadFile.bind(this);
        this.handleOnCancelAddSimpleNote = this.handleOnCancelAddSimpleNote.bind(this);
        this.handleOnSaveSimpleNotes = this.handleOnSaveSimpleNotes.bind(this);
        this.handleOnContinueProcess = this.handleOnContinueProcess.bind(this);
        this.handleModalOk = this.handleModalOk.bind(this);
    }

    componentDidMount() {
        const { requestEstates, requestSummaryDocumentation, resetSummaryDocumentationAction } = this.props;
        resetSummaryDocumentationAction();
        requestEstates();
        requestSummaryDocumentation();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { simpleNoteState, estatesState, summaryDocsState } = nextProps;

        if (estatesState.get('hasBeenFetched') && summaryDocsState.get('documentsRequested')) {
            this.loadData(nextProps);
        }

        if (
            simpleNoteState.get('uploaded') && this.redirect === URLS.REQUEST_NS ||
            simpleNoteState.get('requested') && this.redirect === URLS.UPLOADED_NS
        ) {
            this.props.history.push(this.redirect);
        }
    }


    componentDidUpdate(prevProps, prevState) {
        const { setEstatesState, estatesState, setMultiplesEstatesState } = this.props;
        const estateList = estatesState.get('list');

        if (estateList.size > 0) {
            this.setEstatesStateAsDefault(() => {
                setEstatesState(estateList);
            });
        }

        if (!isEqual(prevState.optionSelected, this.state.optionSelected)) {
            setMultiplesEstatesState(this.state.optionSelected);
        }

    }

    componentWillUnmount() {
        const { resetDocumentsState, resetSimpleNoteState } = this.props;
        resetDocumentsState();
        resetSimpleNoteState();
    }

    setEstatesStateAsDefault = once(cb => cb())

    buildDocumentLinks(estate, estateDoc) {
        const isDocumentUploaded = estateDoc.tipoDocumentoId === DOCUMENTS_TYPES.NS_CLI &&
            estateDoc.estado !== DOCUMENTS_STATUS.NONE &&
            estateDoc.estado !== DOCUMENTS_STATUS.PEND_APORTAR ||
            estateDoc.tipoDocumentoId === DOCUMENTS_TYPES.NS &&
            estateDoc.estado === DOCUMENTS_STATUS.VERIFICADO;

        const documentLink = isDocumentUploaded && (
            <a
                className="ok-link mortgage-request-simple-note__list-item-link"
                onClick={() => this.handleOnDownloadFile(estate, estateDoc)}
            >
                {formatText('mortgageRequestSimpleNote-docLink', [estateDoc.bienId])}
            </a>
        );

        return (
            <div className="col-md-5">
                {documentLink}
            </div>
        );
    }

    buildEstateDetail(estate) {
        let estateType = '';

        switch (estate.tipoBien) {
            case ESTATES_TYPE.VIVIENDA:
                estateType = formatText('mortgageRequestSimpleNote-livingPlace');
                break;
            case ESTATES_TYPE.TRASTERO:
                estateType = formatText('mortgageRequestSimpleNote-storageRoom');
                break;
            case ESTATES_TYPE.GARAJE:
                estateType = formatText('mortgageRequestSimpleNote-garage');
                break;
        }

        const includedEstatesHtml = estate.tipoBien === ESTATES_TYPE.VIVIENDA && this.buildIncludedEstates(estate);

        return (
            <div className="col-md-4">
                <span className="mortgage-request-simple-note__list-item-title">
                    {estateType}
                </span>
                {includedEstatesHtml}
            </div>
        );
    }

    buildEstateDocumentStatus(estate, estateDoc, readOnly) {
        const isRequestOption = this.state.optionSelected[estate.bienId] === SELECT_OPTIONS.REQUEST;
        const isDocumentUploaded = estateDoc.tipoDocumentoId === DOCUMENTS_TYPES.NS_CLI &&
            estateDoc.estado !== DOCUMENTS_STATUS.NONE &&
            estateDoc.estado !== DOCUMENTS_STATUS.PEND_APORTAR ||
            estateDoc.tipoDocumentoId === DOCUMENTS_TYPES.NS &&
            estateDoc.estado === DOCUMENTS_STATUS.VERIFICADO;

        let statusText = '';

        if (isRequestOption && readOnly) {
            if (
                estateDoc.estado === DOCUMENTS_STATUS.NONE ||
                estateDoc.estado === DOCUMENTS_STATUS.PEND_APORTAR ||
                estateDoc.estado === DOCUMENTS_STATUS.BORRADOR ||
                estateDoc.estado === DOCUMENTS_STATUS.PEND_VAL
            ) {
                statusText = formatText('mortgageRequestSimpleNote-requested');
            }
        } else {
            switch (estateDoc.estado) {
                case DOCUMENTS_STATUS.NONE:
                case DOCUMENTS_STATUS.PEND_APORTAR:
                case DOCUMENTS_STATUS.BORRADOR:
                    statusText = formatText('mortgageRequestSimpleNote-pending');
                    break;
                case DOCUMENTS_STATUS.PEND_VAL:
                    statusText = formatText('mortgageRequestSimpleNote-pendingVal');
                    break;
                case DOCUMENTS_STATUS.VERIFICADO:
                    statusText = formatText('mortgageRequestSimpleNote-verified');
                    break;
                case DOCUMENTS_STATUS.NO_VALIDO:
                    statusText = formatText('mortgageRequestSimpleNote-invalid');
                    break;
            }
        }

        const iconClass = classnames('mortgage-request-simple-note__list-item-icon', {
            'mortgage-request-simple-note__list-item-icon--document-none':
                !isRequestOption && (!isDocumentUploaded || estateDoc.estado === DOCUMENTS_STATUS.BORRADOR) ||
                isRequestOption && !readOnly,
            'mortgage-request-simple-note__list-item-icon--document-pending-validation':
                !isRequestOption && estateDoc.estado === DOCUMENTS_STATUS.PEND_VAL ||
                isRequestOption && readOnly && !isDocumentUploaded,
            'mortgage-request-simple-note__list-item-icon--document-verified':
                !isRequestOption && estateDoc.estado === DOCUMENTS_STATUS.VERIFICADO,
            'mortgage-request-simple-note__list-item-icon--document-not-valid':
                !isRequestOption && estateDoc.estado === DOCUMENTS_STATUS.NO_VALIDO
        });

        return (
            <div className="col-md-3 mortgage-request-simple-note__list-item-state">
                <span className={iconClass}></span>
                {statusText}
            </div>
        );
    }

    buildEstateItem(estate, idx) {
        const { readOnly } = this.props;
        const estateDoc = this.estatesDocuments[estate.bienId];

        const estateOptionsHtml = readOnly ?
            this.buildDocumentLinks(estate, estateDoc) :
            this.buildEstateOptions(estate, estateDoc);

        return (
            <div key={idx} className="row mortgage-request-simple-note__list-item">
                {this.buildEstateDetail(estate)}
                {estateOptionsHtml}
                {this.buildEstateDocumentStatus(estate, estateDoc, readOnly)}
            </div>
        );
    }

    buildEstateOptions(estate, estateDoc) {
        const { docCenterState } = this.props;

        const isDocumentUploaded = estateDoc.estado !== DOCUMENTS_STATUS.NONE &&
            estateDoc.estado !== DOCUMENTS_STATUS.PEND_APORTAR;

        const selectDisabled = isDocumentUploaded && estate.notaSimplePropia;
        const ammountFiles = Number(isDocumentUploaded);
        const isFetching = docCenterState.getIn(['isFetching', DOCUMENTS_TYPES.NS_CLI + estate.tipoBien + estate.bienId]);
        const multiples = getMultiples(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const texts = getTexts(DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT, DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME, DRAG_N_DROP_UPLOAD_MAX_SIZE, multiples, DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES);
        const textDescription = getTextDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const textLinkDescription = getTextLinkDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const errorMessage = (this.state.fileErrors) ? this.state.fileErrors[estate.bienId] : DRAG_N_DROP_UPLOAD_ERROR_MESSAGE;
        const uploadDocumentHtml = this.state.optionSelected[estate.bienId] === SELECT_OPTIONS.UPLOAD && (
            <div className="mortgage-request-simple-note__list-item-upload">
                <DragNDropUpload
                    idName={'fileSimpleNote' + estate.bienId}
                    debug={false}
                    onChange={(fileState) => this.handleOnChangeFile(estate.bienId, fileState)}
                    loading={isFetching}
                    error={!!this.state.fileErrors[estate.bienId] && this.state.fileErrors[estate.bienId] !== ''}
                    errorMessage={errorMessage}
                    ammountFiles={ammountFiles}
                    overwriteFile={true}
                    onDownload={() => this.handleOnDownloadFile(estate, estateDoc)}
                    texts={texts}
                    title={DRAG_N_DROP_UPLOAD_TITLE}
                    textDescription={textDescription}
                    textLinkDescription={textLinkDescription}
                    fileText={DRAG_N_DROP_UPLOAD_FILE_TEXT}
                />
            </div>
        );
        const SELECT_OPTIONS_LIST = [
            { value: SELECT_OPTIONS.REQUEST, label: formatText('mortgageRequestSimpleNote-request') },
            { value: SELECT_OPTIONS.UPLOAD, label: formatText('mortgageRequestSimpleNote-upload') }
        ];
        return (
            <div className="col-md-5">
                <OKSelect
                    showLabel={false}
                    name={'optionSimpleNote' + estate.bienId}
                    options={SELECT_OPTIONS_LIST}
                    value={this.state.optionSelected[estate.bienId]}
                    searchable={false}
                    disabled={selectDisabled}
                    onChange={option => this.handleOnChangeSelect(estate.bienId, option)}
                />
                {uploadDocumentHtml}
            </div>
        );
    }

    buildIncludedEstates(estate) {
        let includesText = '';
        let storageRoomText = '';
        let garagesText = '';

        if (estate.storageRooms > 1) {
            storageRoomText = `${estate.storageRooms} ${formatText('mortgageRequestSimpleNote-storageRooms')}`;
        } else if (estate.storageRooms > 0) {
            storageRoomText = `${estate.storageRooms} ${formatText('mortgageRequestSimpleNote-storageRoom')}`;
        }

        if (estate.garages > 1) {
            garagesText = `${estate.garages} ${formatText('mortgageRequestSimpleNote-garages')}`;
        } else if (estate.garages > 0) {
            garagesText = `${estate.garages} ${formatText('mortgageRequestSimpleNote-garage')}`;
        }

        if (storageRoomText && garagesText) {
            includesText = formatText('mortgageRequestSimpleNote-includesAll', [storageRoomText, garagesText]);
        } else if (storageRoomText || garagesText) {
            includesText = formatText('mortgageRequestSimpleNote-includes', [storageRoomText || garagesText]);
        }

        return includesText && (
            <span className="mortgage-request-simple-note__list-item-subtitle">
                {includesText}
            </span>
        );
    }

    handleModalOk() {
        this.props.history.push(URLS.PANEL);
    }

    handleOnCancelAddSimpleNote(evt) {
        evt.preventDefault();

        !this.props.readOnly && recordProcess(PROC_ADD_SIMPLE_NOTE, PROC_CANCEL);
        this.props.history.push(URLS.PANEL);
    }

    handleOnChangeFile(estateId, fileState) {
        if (fileState && !fileState.error) {
            this.props.addFile({
                estateId,
                file: fileState.file
            });
        }
    }

    handleOnChangeSelect(estateId, selectedOption) {
        const optionSelected = cloneDeep(this.state.optionSelected);
        optionSelected[estateId] = selectedOption.value;
        const fileErrors = cloneDeep(this.state.fileErrors);
        fileErrors[estateId] = '';

        this.setState({
            optionSelected,
            fileErrors
        }, () => {
            this.props.setEstateState(estateId, selectedOption);
        });
    }

    handleOnContinueProcess(evt) {
        evt.preventDefault();
        const { history, isClientWithoutAccounts, mortgageRequestState } = this.props;
        const currentState = mortgageRequestState.get('estado');

        if (this.validateAmmountFiles()) {
            if (!isClientWithoutAccounts) {
                this.redirect = URLS.REQUEST_NS;
                this.uploadFiles && this.props.uploadFiles();
            } else if (isClientWithoutAccounts && currentState !== APORTAR_DOC) {
                history.push('/myprofile/mortgage/simple-note-info-payment');
                this.uploadFiles && this.props.uploadFiles();
            } else {
                this.redirect = URLS.REQUEST_NS;
                this.uploadFiles && this.props.uploadFiles();
            }
        }
    }

    handleOnDownloadFile(estate, estateDoc) {
        this.props.requestDocument({
            documentType: estateDoc.tipoDocumentoId,
            documentEstateId: estate.bienId,
            NSType: estate.tipoBien,
            idxDocument: estate.bienId
        });
    }

    handleOnSaveSimpleNotes(evt) {
        evt.preventDefault();

        if (this.validateAmmountFiles()) {
            this.redirect = URLS.UPLOADED_NS;
            this.props.uploadFiles(true);
        }
    }

    loadData(nextProps) {
        const { estatesState, summaryDocsState, simpleNoteState, readOnly } = nextProps;

        let processRestarting = false;
        const optionSelected = clone(this.state.optionSelected);
        const fileErrors = clone(this.state.fileErrors);

        if (isEmpty(this.state.optionSelected)) {
            const estatesList = estatesState.get('list').toJS();
            const estatesDocsList = summaryDocsState.get('data').toJS();

            const livingPlace = filter(estatesList, estate => estate.tipoBien === ESTATES_TYPE.VIVIENDA);
            const storageRooms = filter(estatesList, estate => estate.tipoBien === ESTATES_TYPE.TRASTERO);
            const garages = filter(estatesList, estate => estate.tipoBien === ESTATES_TYPE.GARAJE);

            this.estates = union(takeRight(livingPlace), storageRooms, garages);

            each(this.estates, estate => {
                const estateDoc = find(estatesDocsList, file => {
                    return file.bienId === estate.bienId && file.tipoDocumentoId === DOCUMENTS_TYPES.NS_CLI;
                });
                this.estatesDocuments[estate.bienId] = estateDoc;
                const isDocumentUploaded = estateDoc.estado !== DOCUMENTS_STATUS.NONE &&
                    estateDoc.estado !== DOCUMENTS_STATUS.PEND_APORTAR;

                optionSelected[estate.bienId] = estateDoc && isDocumentUploaded && estate.notaSimplePropia ? SELECT_OPTIONS.UPLOAD : SELECT_OPTIONS.REQUEST;

                const estateHasClientDocument = estateDoc &&
                    estateDoc.tipoDocumentoId === DOCUMENTS_TYPES.NS_CLI &&
                    estateDoc.estado !== DOCUMENTS_STATUS.NONE &&
                    estateDoc.estado !== DOCUMENTS_STATUS.PEND_APORTAR;

                processRestarting = !processRestarting && estateHasClientDocument ? true : processRestarting;
            });

            if (!readOnly) {
                if (processRestarting) {
                    this.savedOptions = clone(optionSelected);
                    recordProcess(PROC_ADD_SIMPLE_NOTE, PROC_RESTART);
                } else {
                    recordProcess(PROC_ADD_SIMPLE_NOTE, PROC_START);
                }
            }
        }

        each(simpleNoteState.get('errorUploading').toJS(), (error, estateId) => {
            fileErrors[estateId] = formatText('mortgageRequestSimpleNote-errorUploadingFile');
        });

        each(simpleNoteState.get('files').toJS(), (file, estateId) => {
            this.uploadFiles[estateId] = true;
        });

        this.setState({
            showModal: isEmpty(this.estates),
            optionSelected,
            fileErrors,
            isUploading: simpleNoteState.get('isUploading') || simpleNoteState.get('isRequesting')
        });
    }

    validateAmmountFiles() {
        this.setState({ fileErrors: {} });
        let allFilled = true;
        let fileErrors = extend({}, this.state.fileErrors);

        each(this.state.optionSelected, (option, estateId) => {
            const estateDoc = this.estatesDocuments[estateId];
            const isValidDoc = estateDoc.estado !== DOCUMENTS_STATUS.NONE &&
                estateDoc.estado !== DOCUMENTS_STATUS.PEND_APORTAR;

            if (option === SELECT_OPTIONS.UPLOAD && !isValidDoc && !this.uploadFiles[estateId]) {
                fileErrors[estateId] = formatText('mortgageRequestSimpleNote-requiredFile');
                allFilled = false;
            }
        });

        this.setState({ fileErrors });
        return allFilled;
    }

    render() {
        const { estatesState, summaryDocsState, readOnly } = this.props

        if (!estatesState.get('hasBeenFetched') || !summaryDocsState.get('documentsRequested')) {
            return <LoadingSection />;
        }
        else if (this.state.showModal) {
            return Modal(this.handleModalOk);
        }

        const estatesListHtml = map(this.estates, (estate, idx) => this.buildEstateItem(estate, idx));

        const allSelectOptionsUpload = every(this.state.optionSelected, option => option === SELECT_OPTIONS.UPLOAD);
        const saveButtonHandler = allSelectOptionsUpload ? this.handleOnSaveSimpleNotes : this.handleOnContinueProcess;
        const saveButtonDisabled = readOnly || allSelectOptionsUpload && isEqual(this.savedOptions, this.state.optionSelected) && isEmpty(this.uploadFiles);
        const saveButtonText = allSelectOptionsUpload ?
            formatText('mortgageRequestSimpleNote-okButtonSave') :
            formatText('mortgageRequestSimpleNote-okButtonContinue');

        return (
            <div className="mortgage-request-simple-note">
                <ContentBox>
                    <OKBoxTitle
                        value={formatText('mortgageRequestSimpleNote-subtitle')}
                        size="medium"
                    />
                    <div className="row">
                        <div className="col-md-12 mortgage-request-simple-note__text">
                            <p>{formatText('mortgageRequestSimpleNote-text1')}</p>
                            <p>{formatText('mortgageRequestSimpleNote-text2')}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <h5 className="mortgage-request-simple-note__title">
                                {formatText('mortgageRequestSimpleNote-estates')}
                            </h5>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 mortgage-request-simple-note__list">
                            {estatesListHtml}
                        </div>
                    </div>
                    <div className="mortgage-request-simple-note__footer">
                        <a href="#" className="ok-link" onClick={this.handleOnCancelAddSimpleNote}>
                            {formatText('mortgageRequestSimpleNote-returnLink')}
                        </a>
                        <OKButton
                            onClick={saveButtonHandler}
                            modifier="primary"
                            loading={this.state.isUploading}
                            disabled={saveButtonDisabled}
                        >
                            {saveButtonText}
                        </OKButton>
                    </div>
                </ContentBox>
            </div>
        );
    }
}

MortgageRequestSimpleNote.propTypes = {
    history: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
    simpleNoteState: PropTypes.object,
    estatesState: PropTypes.object,
    summaryDocsState: PropTypes.object,
    docCenterState: PropTypes.object,
    requestEstates: PropTypes.func,
    setMultiplesEstatesState: PropTypes.func,
    requestSummaryDocumentation: PropTypes.func,
    requestDocument: PropTypes.func,
    addFile: PropTypes.func,
    uploadFiles: PropTypes.func,
    resetDocumentsState: PropTypes.func,
    mortgageRequestState: PropTypes.object,
    resetSimpleNoteState: PropTypes.func,
    isClientWithoutAccounts: PropTypes.bool,
    resetSummaryDocumentationAction: PropTypes.func,
    setEstateState: PropTypes.func,
    setEstatesState: PropTypes.func
};

MortgageRequestSimpleNote.defaultProps = {
    readOnly: false
};

module.exports.constructor = MortgageRequestSimpleNote;

module.exports.MortgageRequestSimpleNote = connect(state => ({
    simpleNoteState: state.mortgageRequestSimpleNote,
    estatesState: state.mortgageRequestInmuebles,
    mortgageRequestState: state.mortgageRequestState,
    summaryDocsState: state.mortgageRequestSummaryDocumentation,
    docCenterState: state.mortgageRequestDocumentationCenter
}), {
        requestEstates: mortgageInmueblesActions.requestInmuebles,
        setMultiplesEstatesState: mortgageInmueblesActions.setMultiplesEstatesState,
        requestSummaryDocumentation: mortgageRequestEstatesActions.fetchSimpleNotes,
        resetSummaryDocumentationAction: mortgageRequestEstatesActions.resetSummaryDocumentation,
        requestDocument: documentActions.getDocument,
        addFile: simpleNoteActions.addFile,
        uploadFiles: simpleNoteActions.uploadFiles,
        resetDocumentsState: documentActions.resetState,
        resetSimpleNoteState: simpleNoteActions.resetState,
        setEstateState: mortgageInmueblesActions.setEstateState,
        setEstatesState: mortgageInmueblesActions.setEstatesState
    })(withRouter(MortgageRequestSimpleNote));
